
<index-panel
  collection="indexes"
  :doc="$route.params.name"
/>
